<div class="overlay privacy-policy-modal">
    <div class="overlay-header">
        <h2>Privacy Policy Consent Required</h2>
    </div>
    <div class="section-divider"></div>
    <form>
        <div class="overlay-body">
            <div class="container"><a href="#" class="opacity-none"> </a>
            <div class="section-heading">Read to the customer:</div>
            <p id="step-1" class="step-dimension" *ngIf="step1Visible">
            Before we proceed with authenticating your account, we need you to agree to our Privacy Policy located 
            at <a href="https://www.alight.com/privacy" target="_blank" rel="noopener noreferrer"> https://www.alight.com/privacy</a>. Do you agree to consent to the policy?


            </p>

            <p id="step-2" class="step-dimension" *ngIf="step2Visible">
               {{privacyPolicyConsent}}
            </p>
            </div>
        </div>
    </form>
  
<div class="button-controls hide1" *ngIf="step1Visible">
  <f-button text="No" title="No" type="button" variant="action" (click)="step1Visible=false; step2Visible=true;">
  </f-button>
  <f-button text="Yes" title="Yes" variant="progressive" type="button" [disabled]="isButtonDisabled" (click)="updatePrivacyPolicy()">
  </f-button>
</div>

<div class="button-controls" *ngIf="step2Visible">
  <f-button text="Back" title="Back" type="button" variant="action" (click)="step1Visible=true; step2Visible=false;">
  </f-button>
  <f-button text="Got it" title="Got it" variant="progressive" type="button" (click)="closePolicyPopup()">
  </f-button>
</div>
<!-- code commented due no feature implemented privacy-link, we will uncomment and use once we have next US realated to privacy policy-link. -->
<p *ngIf="step1Visible" >   
    This window closes after privacy consent is provided.
   If the customer wants some time to review the policy before they consent, <button type="button" class="privacy-link" (click)="navigateToPrivacyPolicy()">click here</button> to send the Privacy Policy link.
</p>
</div>
